module.exports = __webpack_public_path__ + "img/xfbf-bg.5ec645e5.png";